import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface StatCardProps {
  title: string;
  value: string;
  icon: LucideIcon;
  variant: 'income' | 'expense' | 'balance';
}

export function StatCard({ title, value, icon: Icon, variant }: StatCardProps) {
  const variantStyles = {
    income: 'bg-green-500/10 text-green-600 dark:bg-green-500/20 dark:text-green-400',
    expense: 'bg-red-500/10 text-red-600 dark:bg-red-500/20 dark:text-red-400',
    balance: 'bg-blue-500/10 text-blue-600 dark:bg-blue-500/20 dark:text-blue-400'
  };

  const variantTextColors = {
    income: 'text-green-600 dark:text-green-400',
    expense: 'text-red-600 dark:text-red-400',
    balance: 'text-blue-600 dark:text-green-400'
  };

  return (
    <Card className="bg-card border-border transition-all duration-300 hover:shadow-medium hover:bg-accent/30 shadow-soft">
      <CardHeader className="flex flex-row items-center justify-start space-y-0 pb-2 gap-2">
        <div className={`p-2 rounded-xl shadow-soft ${variantStyles[variant]}`}>
          <Icon className="h-4 w-4" />
        </div>
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className={`text-lg font-bold tabular-nums tracking-tight ${variantTextColors[variant]}`}>{value}</div>
      </CardContent>
    </Card>
  );
}